import React, { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import BaseColumnInput from '../../../components/input/base_column_input';
import BaseDatePicker from '../../../components/datepicker/base_datepicker';
// drafttjs editor : https://jpuri.github.io/react-draft-wysiwyg
import BaseEditor from '../../../components/editor';
import { restApi } from '../../../apis';
import dayjs from 'dayjs';
//----------------------------------------------------------------------------------------------------
const CreateNewNotice = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [messageApi, contextHolder] = message.useMessage();
  const { setGModal, loading, setLoading } = props;
  const [data, setData] = useState({
    title: null,
    announceDate: null,
    content: null,
    images: [],
  });
  const isRead = false;
  //----------------------------------------------------------------------------------------------------
  return (
    <div style={{ ...styles.constainer }}>
      {contextHolder}
      <div style={{ ...styles.header }}>
        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
          <Button
            style={{
              display: 'flex',
              width: '2.4rem',
              height: '2.4rem',
              alignItems: 'center',
            }}
            type="text"
            shape="default"
            size="middle"
            icon={
              <img
                width={24}
                height={24}
                src={require('../../../assets/images/ico_goback.png')}
              />
            }
            onClick={(e) => {
              // goback
              // navigate(-1);
              navigate('/notices', {
                replace: false,
                state: {
                  ...location.state,
                  isBack: true,
                },
              });
            }}
          />
          <div style={{ marginLeft: '2rem' }}>{`새로운 공지사항 생성하기`}</div>
        </div>
        <Button
          type="primary"
          // htmlType={'submit'}
          // loading={loading}
          style={{
            display: 'flex',
            width: '21.3rem',
            height: '3.4rem',
            justifyContent: 'center',
            alignItem: 'center',
            // font
            fontWeight: 400,
            fontSize: '1.5rem',
            lineHeight: '2.2rem',
            background: '#FFF',
            color: '#4B465C',

            border: '1px solid #DBDADE',
            borderRadius: 10,
            boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
          }}
          onClick={async (e) => {
            const title = data?.title || '';
            const content = data?.content || '';
            const announceDate = String(
              new dayjs(data?.announceDate || '').format('YYYY-MM-DD 00:00:00')
            ).trim();
            const images = data?.images || [];

            await restApi
              .post('/admin/notification', {
                title,
                content,
                announceDate,
                images,
              })
              .then((res) => {
                messageApi.info('공지사항을 등록하였습니다.');

                setTimeout(() => {
                  navigate('/notices', {
                    replace: false,
                    state: {
                      ...location.state,
                      isBack: true,
                    },
                  });
                }, 500);
                return res;
              })
              .catch((e) => {
                messageApi.error(
                  `[Error] ${e || '공지항을 생성하는데 실패하였습니다.'}`
                );
              });
          }}
        >
          {`새로운 공지사항 생성완료`}
        </Button>
      </div>
      <div style={{ marginTop: 26 }} />
      {/* ---------------------------------------------------------------------------------------------------- */}
      <div style={{ ...styles.sub_menu }}>
        <BaseColumnInput
          label={`공지사항 제목`}
          readonly={isRead}
          onChange={(e) => {
            setData((prev) => {
              return {
                ...prev,
                title: e.target.value,
              };
            });
          }}
          width={'54.2rem'}
          inputStyle={{ height: '3.7rem' }}
          placeholder={'공지사항 제목을 입력해 주세요'}
          // value={'홍길도'}
        />
        <div style={{ width: 26, heigh: 10 }} />
        <BaseDatePicker
          label={`공지할 일시`}
          readonly={isRead}
          onSelectedDate={(e) => {
            // console.log('---->', e);

            setData((prev) => {
              return {
                ...prev,
                announceDate: e,
              };
            });
          }}
          width={'54.2rem'}
          value={data.announceDate}
        />
      </div>
      {/* ---------------------------------------------------------------------------------------------------- */}
      <div style={{ ...styles.body, marginTop: 26 }}>
        <div>공지사항 내용</div>
        {/* <div style={{ ...styles.editor, marginTop: 5 }}> */}
        <BaseEditor
          style={{
            marginTop: 20,
            width: '100%',
            height: '40vh',
            // padding: '20px',
            // border: '1px solid #DBDADE',
          }}
          key={'baseEditor'}
          // html={''}
          images={data.images}
          readonly={isRead}
          setContents={(args) => {
            const html = args.html;
            const images = args.images;
            // console.log('--[images]-->', images);
            setData((prev) => {
              return {
                ...prev,
                content: html,
                images: images,
              };
            });
          }}
          {...props}
        />
        <div style={{ ...styles.body_bottom, marginTop: 5 }}>
          공지사항 내용란으로 1,000자 내로 작성해 주세요.
        </div>
      </div>
      {/* 
      <div
        dangerouslySetInnerHTML={{
          __html: data.content,
        }}
      />
      <div>{data.content}</div> 
      */}
      {/* ---------------------------------------------------------------------------------------------------- */}
      <div style={{ marginTop: 26 }} />
      {/* ---------------------------------------------------------------------------------------------------- */}
    </div>
  );
};

const styles = {
  constainer: {
    display: 'flex',
    width: '100%',
    // flex: 1,
    // height: '100%',
    flexDirection: 'column',

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
  },
  header: {
    display: 'flex',
    width: '100%',
    height: '6.6rem',
    alignItems: 'center',
    padding: '0rem 1rem 0rem 1rem',
    background: '#FFFFFF',
    boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
    borderRadius: '0.6rem',

    alignItems: 'center',
    justifyContent: 'space-between',

    // font
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
    color: '#4B465C',
  },
  sub_menu: {
    display: 'flex',
    width: '100%',
    height: '8.9rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#FFFFFF',
    boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
    padding: '0rem 3rem 0rem 3rem',
    borderRadius: 10,
  },
  body: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    padding: '3rem',
    background: '#FFF',

    boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
    borderRadius: 10,
  },
  body_bottom: {
    fontWeight: 400,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
  },
  editor: {
    width: '100%',
    height: '40vh',
    border: '1px solid #DBDADE',
    borderRadius: 4,
  },
};
export default CreateNewNotice;

/*
background: #FFFFFF;
box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
border-radius: 10px;

owidth: 1210px;
height: 89px;
flex: none;
order: 1;
align-self: stretch;
flex-grow: 0;
*/
